import ModalCloseIcon from './component.jsx'
export default ModalCloseIcon
